import { render, staticRenderFns } from "./taoist.vue?vue&type=template&id=b8f5f298&scoped=true&"
import script from "./taoist.vue?vue&type=script&lang=js&"
export * from "./taoist.vue?vue&type=script&lang=js&"
import style0 from "./taoist.vue?vue&type=style&index=0&id=b8f5f298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5f298",
  null
  
)

export default component.exports